export type FormatRule =
  /* T then show the word 'temporary' P then show the work 'permanent'"
   */
  | 'Cis4TempPermExpansion'
  /**   
    IF database value is PRINT then display post.
    IF database value is EMAIL then display email.
    IF database value is FAX then display fax."
   */
  | 'MethodOfContact'
  | 'OnStopExpansion'
  ;

type StringTransformFunc = (s: string) => string;
type StringFormatRuleMap = Map<FormatRule, StringTransformFunc>;

const m: StringFormatRuleMap = new Map<FormatRule, StringTransformFunc>();

export const cis4TempPermExpansion: StringTransformFunc = (s) => s === 'T' ? 'temporary' : s === 'P' ? 'permanent' : undefined;
m.set('Cis4TempPermExpansion', cis4TempPermExpansion);

export const methodOfContact: StringTransformFunc = (s) => {
  let r = s.toLowerCase();
  if (r === 'print') {
    r = 'post';
  };
  return r;
};
m.set('MethodOfContact', methodOfContact);

export const onStop: StringTransformFunc = (s) => s === 'Y' ? 'on stop' : '';
m.set('OnStopExpansion', onStop);


export function as(value: string, rule: FormatRule) {
  if (!value) return value;
  return m.get(rule)(value);
}


export function yOrN(v: string | String, yesVal: string, noVal: string ): string {
  if (!has(v)) return undefined;
  const chk = v.toLowerCase();
  if (chk === 'y') {
    return yesVal;
  }
  if (chk === 'n') {
    return noVal;
  }
  return undefined;
}

export function has(...args: any[]): boolean {
  const r = args.filter(a => a != undefined && a.toString().trim() !== '');
  return r.length > 0;
}

